import type { Special } from "@/types/content";

export const specials: Special[] = [
  {
    id: "boundaries-of-home",
    title: "家的边界",
    subtitle: "家庭伦理剧十年观察",
    intro:
      "家是最小的伦理单位，也是最难说清的地方。这个专题收录五部围绕家庭关系展开的作品，它们共同关心一个问题：当血缘不再自动等于亲密，家人之间靠什么继续相处？",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20traditional%20Japanese%20house%20interior%20at%20dusk%20with%20a%20low%20table%2C%20paper%20screens%20and%20warm%20lamp%20light%2C%20empty%20rooms%2C%20deep%20navy%20shadows%20and%20amber%20highlights%2C%20editorial%20film%20still%2C%20no%20text&width=1200&height=600&seq=sp-01&orientation=landscape",
    groups: [
      {
        title: "同一屋檐下的秩序",
        note: "两部作品都把镜头放在餐桌与玄关：家人如何让路、如何摆放鞋子，比任何台词都更能说明关系的真实状态。",
        movieIds: ["white-porcelain", "three-under-the-eaves", "backlit-dining-table"],
      },
      {
        title: "照护与亏欠",
        note: "当照护成为某个家庭成员默认的义务，伦理问题就从个人品德转向了分配。这两部作品让照护的消耗被看见。",
        movieIds: ["mother-in-mirror", "words-i-never-said"],
      },
    ],
  },
  {
    id: "silence-and-testimony",
    title: "沉默与言说",
    subtitle: "社会伦理题材中的证词叙事",
    intro:
      "有些真相无法被完整说出，有些证词必须以沉默的形式存在。本专题聚焦四部涉及制度、身份与职业伦理的作品，讨论个体在结构之中如何保留判断的权利。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20courthouse%20corridor%20with%20tall%20windows%20and%20long%20shadows%20on%20a%20stone%20floor%2C%20cool%20grey%20blue%20tones%2C%20austere%20editorial%20mood%2C%20no%20text&width=1200&height=600&seq=sp-02&orientation=landscape",
    groups: [
      {
        title: "制度中的个人",
        note: "法庭、诊所、户籍窗口——这些空间规定了人可以说什么、以什么身份说话。三部作品让角色在规则边缘做出选择。",
        movieIds: ["silent-testimony", "borrowed-name", "midnight-clinic"],
      },
      {
        title: "共同体与土地",
        note: "当开发计划进入山村，伦理问题不再是个人选择，而是共同体如何定义自己的未来。",
        movieIds: ["testimony-of-the-mountain"],
      },
    ],
  },
  {
    id: "afterglow-of-showa",
    title: "昭和余晖",
    subtitle: "旧空间里的伦理记忆",
    intro:
      "长屋、站台、纸门与蝉鸣，构成了日本伦理影视中最具辨识度的空间记忆。本专题的三部作品都以旧空间为舞台，让时代的变化落在具体的人身上。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20old%20Japanese%20wooden%20nagaya%20alley%20at%20dusk%20with%20hanging%20lanterns%20and%20potted%20plants%2C%20faded%20warm%20light%2C%20muted%20rust%20and%20deep%20green%20palette%2C%20nostalgic%20editorial%20film%20still%2C%20no%20text&width=1200&height=600&seq=sp-03&orientation=landscape",
    groups: [
      {
        title: "邻里之间",
        note: "纸门薄得能听见一切，却厚得让人不敢推开。关心与侵入之间的那条线，构成了邻里伦理的全部张力。",
        movieIds: ["beyond-the-paper-door", "season-of-cicadas"],
      },
      {
        title: "离去与留下",
        note: "一座即将停用的小站，成了父子之间最后的谈判桌。离开有其正当性，留下也需要被看见。",
        movieIds: ["platform-homeward", "the-blank-page"],
      },
    ],
  },
];